import React, { ChangeEvent, useRef, useState, useEffect, forwardRef, useCallback } from "react";
import CardLayout from "react-lib/apps/common/CardLayout";
import ModInfo from "react-lib/apps/common/ModInfo";
import PatientIdentification from "react-lib/apps/common/PatientIdentification";
import SubScannerForm from "react-lib/apps/common/SubScannerForm";
import { Button, Grid, Segment, Form } from "semantic-ui-react";

import Viewer from "react-viewer";

import { pdfjs } from "react-pdf";
import { PDFDocument, degrees } from "pdf-lib";

import PureReactTable, { alignCenter } from "react-lib/apps/common/PureReactTable";
import * as CAgent from "react-lib/apps/common/CAgent";
// import Zoom from "../../../_qmljs/Common/Zoom";
import { printURL } from "react-lib/utils/printURL";

import ModConfirm from "react-lib/apps/common/cnmi/ModConfirm";
import { base64toBlob } from "react-lib/apps/HISV3/common/CommonInterface";

// Config
import CONFIG from "config/config";
import ButtonLoadCheck from "react-lib/appcon/common/ButtonLoadCheck";
import { useIntl } from "react-intl";
import { DEFAULT_DATA } from "../../../utils/defaultData";
interface CardScannerProps {
  patientData?: Record<string, any>;
  patientInfo?: Record<string, any>;
  controller?: Record<string, any>;
  setProp?: (key: any, value: any, callback?: () => any) => any;
  onClose?: () => void;
  onCloseModal?: () => void;
  patientId?: number | string;
  onNoPatient?: () => void;
  django?: Record<string, any>;
  scanCompleted?: () => void;
  encounterId?: number | string;
  closeable?: boolean;
  toggleable?: boolean;
  showDocumentCategory?: boolean;
  ownerDivision?: number;
  categoryCode?: string;
  hideDoctor?: boolean;
  hideLayOut?: boolean;
  hidePatientIDE?: boolean;
  disabledDocType?: boolean;
  isGrouped?: boolean;
  disabledDocCategory?: boolean;
  isViewDocumant?: boolean;
  isMeBilling?: boolean;
  documentCategoryId?: number | string;
  selectedEncounter?: Record<string, any>;
  selectedDivision?: Record<string, any>;
  languageUX?: string;
}

// ตั้งค่า worker
pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const FrameChrome = ({ file }: { file: string }) => {
  if (!file) {
    return null;
  }

  const frame = `<iframe src="${file}" width="100%" height="100%"></iframe>`;

  return (
    <div dangerouslySetInnerHTML={{ __html: frame }} style={{ height: "100%", width: "100%" }} />
  );
};

const DEFAULT_PROPS = {
  patientData: {},
  patientInfo: {},
  controller: {},
  django: {},
  onClose: () => {},
  patientId: null,
  encounterId: null,
  onNoPatient: () => {},
  scanCompleted: () => {},
  closeable: true,
  toggleable: false,
  showDocumentCategory: true,
  categoryCode: "",
  hideDoctor: false,
  hideLayOut: false,
  hidePatientIDE: false,
  disabledDocType: false,
  isGrouped: false,
  isViewDocumant: false,
};
//! This is ModScanner in QML except this card does not appear in modal
const CardScanner = forwardRef<any, CardScannerProps>((propsParam, ref) => {
  const props = {
    ...DEFAULT_PROPS,
    ...Object.fromEntries(Object.entries(propsParam).filter(([_, value]) => value !== undefined)),
  };
  const intl = useIntl();
  const [buttonState, setButtonState] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [openModError, setOpenModError] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [scanData, setScanData] = useState<any[]>([]);
  const [image, setImage] = useState("");
  const [openModConfirmClose, setOpenModConfirmClose] = useState(false);
  const [openModConfirmRemove, setOpenModConfirmRemove] = useState(false);
  const [openModConfirmSave, setOpenModConfirmSave] = useState(false);
  const [modConfirmRemoveText, setModConfirmRemoveText] = useState(null);
  const [divisionOptions, setDivisionOptions] = useState<any[]>([]);
  const [categoryOptions, setCategoryOptions] = useState<any[]>([]);
  const [openModSuccess, setOpenModSuccess] = useState(false);
  const [modErrorTitle, setModErrorTitle] = useState("แจ้งเตือน");
  const [isLoadingScan, setIsLoadingScan] = useState(false);
  const [pdfBlob, setPdfBlob] = useState("");

  const dataId = useRef(0);
  const isMounted = useRef(false);
  const subScannerFormRef = useRef();
  const inputRef = useRef<any>();
  const savedDocIdNamesRef = useRef({});
  const savedDocListRef = useRef<any[]>([]);

  const generateDocumentImage = useCallback(async (items: any[] = [], selectedRow: any) => {
    const pdfDoc = await PDFDocument.create();

    if (items.length === 0 || !selectedRow) {
      return "";
    }

    try {
      const filteredItems = items.filter(
        (item) => item.document_type === selectedRow.document_type,
      );

      for (const item of filteredItems) {
        const docImage = item.document_image;

        const jpgImage: any = await pdfDoc.embedJpg(docImage);
        const jpgDims = jpgImage.scale(0.5);

        const page = pdfDoc.addPage([jpgDims.width, jpgDims.height]);

        page.drawImage(jpgImage, {
          height: jpgDims.height,
          opacity: 1,
          rotate: degrees(0),
          width: jpgDims.width,
          x: 0,
          y: 0,
        });
      }
    } catch (error) {
      console.error("error:", error);

      return "";
    }

    return pdfDoc.saveAsBase64({ dataUri: true });
  }, []);

  const handleSetDocumentImage = useCallback(async (items: any[] = [], selectedRow: any) => {
    const pdf = await generateDocumentImage(items, selectedRow);

    const blob = pdf ? URL.createObjectURL(base64toBlob(pdf)) : "";

    setPdfBlob(blob);
  }, []);

  useEffect(() => {
    isMounted.current = true;
    if (!props.patientId && !props.encounterId) {
      props.onNoPatient();
      props.onClose();
    }

    const getDivision = async () => {
      const [data, error] = await props.controller.getDivision({
        limit: "99999",
      });
      if (isMounted.current) {
        if (data) {
          setDivisionOptions(data);
        } else {
          setDivisionOptions([]);
        }
      }
    };

    const getCategory = async () => {
      const [data, error] = await props.controller.getDocumentCategory({
        limit: "99999",
      });
      if (isMounted.current) {
        if (data) {
          setCategoryOptions(data);

          const defaultCategory = props.categoryCode || "UNDEFINED";
          const notSpecifiedId = data.find((item) => item.code === defaultCategory)?.id;

          (subScannerFormRef as any).current.changeCategory(notSpecifiedId);
        } else {
          setCategoryOptions([]);
        }
      }
    };

    getDivision();
    getCategory();
    return () => {
      isMounted.current = false;
    };
  }, []);

  useEffect(() => {
    if (["SUCCESS", "ERROR"].includes(buttonState)) {
      setTimeout(() => {
        setButtonState("");
      }, 2000);
    }
  }, [buttonState]);

  useEffect(() => {
    if (selectedRow) {
      setImage("data:image/jpeg;base64," + (selectedRow as any).document_image);
    } else {
      setImage("");
    }
  }, [selectedRow]);

  useEffect(() => {
    handleSetDocumentImage(scanData, selectedRow);
  }, [scanData, selectedRow]);

  const handleScanClicked = () => {
    if (CONFIG.SCAN_VIA_FILE_BROWSE) {
      return inputRef.current.click();
    }

    setIsLoading(true);
    console.log(props.django);
    // CAgent.setMockupScannedImage(props.django); //! Only for dev, comment before commit
    CAgent.checkCAgentScanListAvailable(
      () => scanList(),
      () => scan(),
    );
  };

  const getDocumentType = async ({ category, name }: any = {}) => {
    setError(null);
    const [data, error] = await props.controller.getDocumentType({
      limit: "99999",
      category,
      name,
      division: props.django && props.django.division ? props.django.division.id : "current",
    });
    return [data, error];
  };

  const scanList = () => {
    // * Single image
    // * CAgent.scan(function(base64imageList) {

    // * List image
    CAgent.scanList(handleScanList, function (error: any) {
      setIsLoading(false);
      setError(error);
      setModErrorTitle("แจ้งเตือน");
      setOpenModError(true);
    });
  };

  const handleScanList = (base64imageList: any[]) => {
    let lists: any[] = [...scanData];

    for (let i = 0; i < base64imageList.length; i++) {
      let base64image = base64imageList[i];
      let prefix = "data:image/jpeg;base64,";
      if (base64image.startsWith(prefix)) {
        base64image = base64image.slice(prefix.length);
      }
      addList(base64image, i + 1, lists);
      setScanData([...lists]);
      showPreview(base64image);
      props.scanCompleted(base64image);
    }
    setIsLoading(false);
    (subScannerFormRef as any).current.clearForm();

    if (props.ownerDivision) {
      (subScannerFormRef as any).current.changeOwnerDivision(props.ownerDivision);
    }
  };

  const addList = (base64image: any, i: any, lists?: any[]) => {
    let row = (subScannerFormRef as any).current.fillRow();
    row.document_image = base64image;
    row.code = "";
    row.id = "fakeId" + dataId.current;
    if (i !== -1) {
      row.page_number = i;
    }

    if (lists) {
      lists.push(row);
    } else {
      let newArr: any[] = [...scanData];

      newArr.push(row);

      setScanData(newArr as any);
    }

    dataId.current = dataId.current + 1;
  };

  const showPreview = (base64image: any) => {
    if (!base64image) {
      setImage("");
    }
    setImage("data:image/jpeg;base64," + base64image);
  };

  const scan = () => {
    CAgent.scan(
      function (base64image: any) {
        var prefix = "data:text/xml;base64,";
        if (base64image.startsWith(prefix)) {
          base64image = base64image.slice(prefix.length);
        }
        addList(base64image, -1);
        showPreview(base64image);
        props.scanCompleted(base64image);
        setIsLoading(false);
        (subScannerFormRef as any).current.clearForm();
      },
      function (error: any) {
        setIsLoading(false);
        setError(error);
        setModErrorTitle("แจ้งเตือน");
        setOpenModError(true);
      },
      props.django,
    );
  };

  const handleClose = () => {
    if (scanData.length === 0) {
      if (props.isViewDocumant) {
        props.onCloseModal();
      }

      return props.onClose(savedDocIdNamesRef.current);
    }
    setOpenModConfirmClose(true);
  };

  const handleRemoveClick = ({ row }: any) => {
    setOpenModConfirmRemove(true);
    setModConfirmRemoveText(
      `ต้องการลบ ${row.original.document_type_name} หมายเลข ${row.index + 1} ใช่หรือไม่` as any,
    );
  };

  const handleRemoveItem = () => {
    let newArr = scanData.filter((item: any) => item.id !== (selectedRow as any).id);
    setScanData([...newArr]);
    setOpenModConfirmRemove(false);
    setSelectedRow(null);
    (subScannerFormRef as any).current.clearForm();
  };

  const handleEditItem = () => {
    let newRow = (subScannerFormRef as any).current.fillRow();
    let cpSelectedRow = { ...(selectedRow as any), ...newRow };
    (subScannerFormRef as any).current.clearForm();
    let index = scanData.findIndex((item: any) => item.id === cpSelectedRow.id);
    let newArr: any[] = [...scanData];
    newArr[index] = cpSelectedRow;
    setSelectedRow(null);
    setScanData(newArr as any);
  };

  const handleSaveItem = () => {
    // * Save Each Item
    setOpenModConfirmSave(false);

    const data = [...scanData];
    const formattedData = data.map((item: any) => {
      const newObj = { ...item };

      const foundData = savedDocListRef.current.find((acc) => acc.base64 === newObj.document_image);

      // ลบ fake ID
      if (newObj.id?.includes("fakeId")) {
        delete newObj.id;
      }

      newObj.fileName = foundData.fileName || "";
      newObj.patient = props.patientId;
      newObj.encounter = props.encounterId;

      // ตั้งค่า default values
      if (!newObj.version) {
        newObj.version = 0;
      }

      if (!newObj.owner_division) {
        newObj.owner_division = 0;
      }

      return newObj;
    });

    const promiseArr = formattedData.map(async (item) => save({ saveData: item }));

    setButtonState("LOADING");
    setIsLoading(true);

    Promise.allSettled(promiseArr).then((result) => {
      let success = result.filter((item) => item.status === "fulfilled");
      let fail = result.filter((item) => item.status === "rejected");
      if (success.length === promiseArr.length) {
        setIsLoading(false);
        // setOpenModSuccess(true);
        setScanData([]);
        setButtonState("SUCCESS");

        const idNames = Object.fromEntries(
          result.map((item: any, index: number) => [
            item.value.id as number,
            formattedData[index]?.fileName || "",
          ]),
        );

        savedDocIdNamesRef.current = { ...savedDocIdNamesRef.current, ...idNames };
      } else {
        setIsLoading(false);
        let reason = fail.filter((item: any) => item.reason.hasOwnProperty("owner_division"));
        setButtonState("ERROR");
        if (reason.length > 0) {
          setError("กรุณาระบุ 'แผนกเจ้าของเอกสาร'" as any);
          setModErrorTitle("ไม่สามารถบันทึกเอกสารได้");
        } else {
          setError("กรุณาตรวจสอบข้อมูลเอกสาร" as any);
        }
        setOpenModError(true);
      }
    });
  };

  const save = async ({ saveData }: any = {}) => {
    const response = await props.controller.postScannedDocument({
      data: {
        ...saveData,
        ...(props.isViewDocumant && {
          owner_division: props.selectedDivision?.id || saveData.owner_division,
        }),
      },
    });
    return response;
  };

  const toBase64 = async (file: File): Promise<{ base64: string; fileName: string }> =>
    new Promise((resolve) => {
      const reader = new FileReader();

      reader.readAsDataURL(file);

      reader.onload = () => {
        const base64 = (reader.result as string).replace(/^.*,/, "");

        resolve({ base64, fileName: file.name });
      };

      reader.onerror = () => {
        resolve({ base64: "", fileName: "" });
      };
    });

  const convertPDFToImages = async (files: File[]) => {
    const images: { base64: string; fileName: string }[] = [];

    for (const file of files) {
      const pdf = await pdfjs.getDocument(URL.createObjectURL(file)).promise;

      for (let pageNumber = 1; pageNumber <= pdf.numPages; pageNumber++) {
        const page = await pdf.getPage(pageNumber);
        const scale = 2;
        const viewport = page.getViewport({ scale });

        const canvas = document.createElement("canvas");

        // set size
        canvas.style.width = `${viewport.width}px`;
        canvas.style.height = `${viewport.height}px`;

        // set actual pixel size
        const pixelRatio = window.devicePixelRatio || 1;

        canvas.width = viewport.width * pixelRatio;
        canvas.height = viewport.height * pixelRatio;

        const context = canvas.getContext("2d", {
          alpha: false,
          willReadFrequently: true,
        });

        // scale for high DPI displays
        context?.scale(pixelRatio, pixelRatio);

        // render
        const renderContext = {
          canvasContext: context,
          enableWebGL: true,
          viewport,
        };

        await page.render(renderContext).promise;

        // convert to image
        const imageData = canvas.toDataURL("image/jpeg", 1);

        // สร้างชื่อไฟล์จากชื่อ PDF + หมายเลขหน้า
        const baseName = file.name.replace(/\.pdf$/i, "");
        const imageName = `${baseName} (${pageNumber}).jpg`;

        images.push({
          base64: imageData.replace(/^.*,/, ""),
          fileName: imageName,
        });

        canvas.remove();
      }
    }

    return images;
  };

  const handleFileInputChange = async (e: ChangeEvent<HTMLInputElement>) => {
    setIsLoadingScan(true);

    const { files } = e.target;

    if (files?.length) {
      const promises = [...files].map(async (file) => toBase64(file));

      try {
        const base64Data = await Promise.all(promises);

        const imagesJpeg = base64Data.filter((file) => file.base64.startsWith("/9j/"));
        const pdfFiles = [...files].filter((file) => file.name.endsWith(".pdf"));
        const images = await convertPDFToImages(pdfFiles);

        savedDocListRef.current = [...savedDocListRef.current, ...imagesJpeg, ...images];

        handleScanList([
          ...imagesJpeg.map((image) => image.base64),
          ...images.map((image) => image.base64),
        ]);

        inputRef.current.value = "";
      } catch (error: any) {
        console.error(`Error converting files to base64: ${error.message}`);
      }
    }

    setIsLoadingScan(false);
  };

  const handleModConfirmClose = () => {
    setImage("");
    setScanData([]);
    setSelectedRow(null);
    setOpenModConfirmClose(false);
    (subScannerFormRef as any).current.clearForm();

    if (props.isViewDocumant) {
      props.onCloseModal();
    }
    props.onClose(savedDocIdNamesRef.current);

    savedDocIdNamesRef.current = {};
    savedDocListRef.current = [];
  };

  const handleGetSearchOptions = async ({ searchText = "" }) =>
    props.controller.getDoctor({ search: searchText });

  const scannerContent = (
    <ScannerContent
      props={props}
      pdfBlob={pdfBlob}
      image={image}
      selectedRow={selectedRow}
      scanData={scanData}
      subScannerFormRef={subScannerFormRef}
      inputRef={inputRef}
      divisionOptions={divisionOptions}
      categoryOptions={categoryOptions}
      buttonState={buttonState}
      isLoadingScan={isLoadingScan}
      setSelectedRow={setSelectedRow}
      setImage={setImage}
      setOpenModConfirmSave={setOpenModConfirmSave}
      handleScanClicked={handleScanClicked}
      handleEditItem={handleEditItem}
      handleClose={handleClose}
      handleRemoveClick={handleRemoveClick}
      handleFileInputChange={handleFileInputChange}
      handleGetSearchOptions={handleGetSearchOptions}
      getDocumentType={getDocumentType}
    />
  );

  return (
    <>
      <ModConfirm
        className="fixNotMiddleModal"
        testid="modConfirmSave"
        titleColor="red"
        centered
        openModal={openModConfirmSave}
        content={<div>{intl.formatMessage({ id: "ไม่ต้องการสแกนเอกสารเพิ่มแล้วใช่หรือไม่" })}</div>}
        onDeny={() => setOpenModConfirmSave(false)}
        onApprove={handleSaveItem}
        onCloseWithDimmerClick={() => setOpenModConfirmSave(false)}
      />
      <ModConfirm
        className="fixNotMiddleModal"
        testid="modConfirmRemove"
        titleColor="red"
        centered
        openModal={openModConfirmRemove}
        content={<div>{modConfirmRemoveText}</div>}
        onDeny={() => setOpenModConfirmRemove(false)}
        onApprove={handleRemoveItem}
        onCloseWithDimmerClick={() => setOpenModConfirmRemove(false)}
      />
      <ModConfirm
        className="fixNotMiddleModal"
        testid="modConfirmClose"
        openModal={openModConfirmClose}
        titleColor="red"
        centered
        content={<div>{intl.formatMessage({ id: "มีเอกสารที่สแกนอยู่ ปิดหน้าจอหรือไม่" })}</div>}
        onDeny={() => setOpenModConfirmClose(false)}
        onApprove={handleModConfirmClose}
        onCloseWithDimmerClick={() => setOpenModConfirmClose(false)}
      />
      <ModInfo
        className="fixNotMiddleModal"
        // @ts-ignore
        testid="modError"
        open={openModError}
        titleColor="red"
        titleName={modErrorTitle}
        alertText={error}
        onApprove={() => setOpenModError(false)}
        onCloseWithDimmerClick={() => setOpenModError(false)}
      />
      <ModInfo
        className="fixNotMiddleModal"
        // @ts-ignore
        testid="modSuccess"
        open={openModSuccess}
        titleColor="green"
        titleName="บันทึกสำเร็จ"
        centered
        onApprove={() => {
          setOpenModSuccess(false);
          props.onClose(savedDocIdNamesRef.current);
        }}
        onCloseWithDimmerClick={() => setOpenModSuccess(false)}
      />

      {props.hideLayOut ? (
        scannerContent
      ) : (
        <CardLayout
          titleText="สแกนเอกสาร"
          loading={isLoading}
          loadingText="กำลังสแกน"
          onClose={handleClose}
          headerColor="yellow"
          toggleable={props.toggleable}
          closeable={props.closeable}
          dimmerStyle={{ ...(props.isViewDocumant && { visibility: "hidden" }) }}
        >
          {scannerContent}
        </CardLayout>
      )}
    </>
  );
});

type ScannerContentProps = {
  props: any;
  pdfBlob: string;
  image: string;
  selectedRow: any;
  scanData: any[];

  subScannerFormRef: any;
  inputRef: any;

  divisionOptions: any[];
  categoryOptions: any[];

  buttonState: string;
  isLoadingScan: boolean;

  setSelectedRow: React.Dispatch<any>;
  setImage: React.Dispatch<React.SetStateAction<string>>;
  setOpenModConfirmSave: React.Dispatch<React.SetStateAction<boolean>>;

  handleScanClicked: () => void;
  handleEditItem: () => void;
  handleClose: () => void;
  handleRemoveClick: ({ row }: any) => void;
  handleFileInputChange: (e: ChangeEvent<HTMLInputElement>) => void;
  handleGetSearchOptions: ({ searchText }: any) => Promise<any>;
  getDocumentType: ({ category, name }: any) => Promise<any>;
};

const ScannerContent = ({
  props,
  pdfBlob,
  image,
  selectedRow,
  scanData,
  subScannerFormRef,
  inputRef,
  divisionOptions,
  categoryOptions,
  buttonState,
  isLoadingScan,
  setSelectedRow,
  setImage,
  setOpenModConfirmSave,
  handleScanClicked,
  handleEditItem,
  handleClose,
  handleRemoveClick,
  handleFileInputChange,
  handleGetSearchOptions,
  getDocumentType,
}: ScannerContentProps) => {
  return (
    <div style={{ ...(props.isViewDocumant && { visibility: "visible", marginTop: "-60px" }) }}>
      {/* <Zoom ref={zoomRef as any} /> */}
      {!props.hidePatientIDE && <PatientIdentification patientInfo={props.patientInfo} />}
      <Grid columns={2}>
        <Grid.Column>
          <Segment id="container" color="grey" inverted style={styles.segment}>
            {/* <img
                // @ts-ignore
                testid="imgScanned"
                style={styles.image}
                src={image}
                onClick={(e) => {
                  // (zoomRef as any).current.qml.show(image, e);
                }}
              /> */}
            {props.isGrouped ? (
              <FrameChrome file={pdfBlob} />
            ) : (
              <Viewer
                visible={!!image}
                onClose={() => {
                  setSelectedRow(null);
                  setImage("");
                }}
                // activeIndex={this.state.imgActiveIndex}
                images={[{ src: image }]}
                container={document.getElementById("container")}
              />
            )}
          </Segment>
        </Grid.Column>
        <Grid.Column style={{ paddingLeft: "0px" }}>
          <SubScannerForm
            ref={subScannerFormRef}
            // @ts-ignore
            onScanClicked={handleScanClicked}
            onGetDocumentTypeOptions={({ searchText, documentCategory }: any = {}) =>
              getDocumentType({ name: searchText, category: documentCategory })
            }
            data={selectedRow}
            cancelEditClicked={() => {
              setSelectedRow(null);
              (subScannerFormRef as any).current.clearForm();
            }}
            onEditClicked={handleEditItem}
            divisionOptions={divisionOptions}
            defaultDocName={props.defaultDocName}
            languageUX={props.languageUX}
            isLoadingScan={isLoadingScan}
            showDocumentCategory={props.showDocumentCategory ?? true}
            hideDoctor={props.hideDoctor}
            disabledDocType={props.disabledDocType}
            disabledDocCategory={props.disabledDocCategory}
            categoryOptions={categoryOptions}
            ownerDivision={props.ownerDivision}
            categoryCode={props.categoryCode}
            onGetSearchOptions={handleGetSearchOptions}
            // viewDocument
            isViewDocumant={props.isViewDocumant}
            isMeBilling={props.isMeBilling}
            documentCategoryId={props.documentCategoryId}
            selectedEncounter={props.selectedEncounter}
            buttonSearch={props.buttonSearch}
          />
          <PureReactTable
            testid="scannedDocTable"
            className=""
            selectedClassName="blueSelectedRow"
            style={styles.scannedDocTable}
            showPagination={false}
            showPageSizeOptions={false}
            minRows={5}
            data={scanData}
            onSelect={(originalRow: any) => {
              setSelectedRow(originalRow);
              setImage("data:image/jpeg;base64," + originalRow.document_image);
            }}
            selectedRow={selectedRow}
            columns={
              props.isViewDocumant
                ? [
                    {
                      Header: "NO.",
                      accessor: "number",
                      width: 50,
                      Cell: (row: any) => {
                        return alignCenter(row.index + 1);
                      },
                    },
                    {
                      Header: "ชื่อเอกสาร",
                      accessor: "document_type_name",
                    },
                    {
                      Header: "วันที่เอกสาร",
                      accessor: "document_date",
                    },
                    {
                      Header: "ลบ",
                      accessor: "remove",
                      minWidth: 50,
                      Cell: (row: any) => {
                        return alignCenter(
                          <Button
                            color="red"
                            icon="remove"
                            onClick={() => handleRemoveClick({ row })}
                          />,
                        );
                      },
                    },
                  ]
                : [
                    {
                      Header: "NO.",
                      accessor: "number",
                      width: 50,
                      Cell: (row: any) => {
                        return alignCenter(row.index + 1);
                      },
                    },
                    {
                      Header: "ชื่อเอกสาร",
                      accessor: "document_type_name",
                    },
                    {
                      Header: "วันที่เอกสาร",
                      accessor: "document_date",
                    },
                    {
                      Header: "เลขที่เอกสาร",
                      accessor: "document_no",
                    },
                    {
                      Header: "พิมพ์",
                      accessor: "_print",
                      Cell: (row: any) => {
                        return alignCenter(
                          <Button
                            color="teal"
                            icon="print"
                            onClick={() => {
                              let prefix = "data:image/jpeg;base64,";
                              printURL(prefix + row.original.document_image);
                            }}
                          />,
                        );
                      },
                    },
                    {
                      Header: "ลบ",
                      accessor: "remove",
                      minWidth: 50,
                      Cell: (row: any) => {
                        return alignCenter(
                          <Button
                            color="red"
                            icon="remove"
                            onClick={() => handleRemoveClick({ row })}
                          />,
                        );
                      },
                    },
                  ]
            }
          />
          <br />
          <Form>
            <Form.Group inline className="rightAlign">
              <Form.Field>
                <Button color="red" content="ยกเลิก" onClick={handleClose} />
              </Form.Field>
              <Form.Field>
                <ButtonLoadCheck
                  // function
                  id="btn-confirmData"
                  setProp={props.setProp}
                  onClick={() => setOpenModConfirmSave(true)}
                  // data
                  buttonLoadCheck={buttonState}
                  color="green"
                  title="บันทึก"
                />
              </Form.Field>
            </Form.Group>
          </Form>
        </Grid.Column>
      </Grid>

      <input
        ref={inputRef}
        type="file"
        id="fileInput"
        accept=".jpg, .jpeg, .pdf, application/pdf"
        multiple
        hidden
        onChange={handleFileInputChange}
      />
    </div>
  );
};

const styles = {
  scannedDocTable: {
    height: "350px",
  },
  segment: {
    height: "100%",
    overflowY: "auto",
    display: "flex",
    justifyContent: "center",
  },
  image: { cursor: "zoom-in", height: "400px" },
};

CardScanner.displayName = "CardScanner";

export default React.memo(CardScanner);
